import type { ModuleDef } from "../types";
import { defineModule } from "./define";

export const STRUCTURAL: ModuleDef[] = [
  defineModule({
    id: "hull_plate_mk1",
    name: "Hull Plate Mk.I",
    category: "structural",
    tier: 1,
    cells: { w: 1, h: 1 },
    sprite: "hull_plate_mk1",
    stats: {
      mass: 120, hp: 80,
      tensile: 400_000_000,
      hardness: 0.3,
      thermalConductivity: 1.0,
      thermalEmissivity: 0.7,
    },
  }),
  defineModule({
    id: "longeron_2x1",
    name: "Longeron Beam",
    category: "structural",
    tier: 1,
    cells: { w: 2, h: 1 },
    sprite: "longeron_2x1",
    stats: {
      mass: 200, hp: 140,
      tensile: 500_000_000,
      hardness: 0.35,
      thermalConductivity: 0.05,
      thermalEmissivity: 0.5,
    },
  }),
  defineModule({
    id: "insulator_beam_2x1",
    name: "Insulator Beam",
    category: "structural",
    tier: 2,
    cells: { w: 2, h: 1 },
    sprite: "insulator_beam_2x1",
    stats: {
      mass: 240, hp: 140,
      tensile: 450_000_000,
      hardness: 0.1,
      thermalConductivity: 0.0001,
      thermalEmissivity: 0.05,
      meltPointK: 1500,
    },
  }),
  defineModule({
    id: "conductivity_beam_2x1",
    name: "Conductivity Beam",
    category: "structural",
    tier: 2,
    cells: { w: 2, h: 1 },
    sprite: "conductivity_beam_2x1",
    stats: {
      mass: 240, hp: 140,
      tensile: 450_000_000,
      hardness: 0.1,
      thermalConductivity: 4.3,
      thermalEmissivity: 0.4,
      meltPointK: 2273,
    },
  }),
  defineModule({
    id: "conductivity_node_1x1",
    name: "Conductivity Node",
    category: "structural",
    tier: 2,
    cells: { w: 1, h: 1 },
    sprite: "conductivity_node_1x1",
    stats: {
      mass: 120, hp: 70,
      tensile: 450_000_000,
      hardness: 0.1,
      thermalConductivity: 4.3,
      thermalEmissivity: 0.4,
      meltPointK: 2273,
    },
  }),
  defineModule({
    id: "armor_plate_mk2",
    name: "Composite Armor Mk.II",
    category: "armor",
    tier: 2,
    cells: { w: 1, h: 1 },
    sprite: "armor_plate_mk2",
    stats: {
      mass: 240, hp: 220,
      tensile: 1_500_000_000,
      hardness: 0.9,
      thermalConductivity: 0.3,
      thermalEmissivity: 0.1,
    },
  }),
  defineModule({
    id: "cockpit_mk1",
    name: "Cockpit Mk.I",
    category: "cockpit",
    tier: 1,
    cells: { w: 1, h: 1 },
    sprite: "cockpit_mk1",
    stats: {
      mass: 180, hp: 60,
      tensile: 300_000_000,
      hardness: 0.25,
      crew: 1,
      powerIdleW: 400, powerActiveW: 1_200,
      energyEfficiency: 0.5,
      thermalConductivity: 0.5,
      thermalInertia: 800,
      thermalEmissivity: 0.6,
      meltPointK: 1400,
    },
  }),
  defineModule({
    id: "insulation_plate_mk1",
    name: "Thermal Insulation Mk.I",
    category: "structural",
    tier: 1,
    cells: { w: 1, h: 1 },
    sprite: "insulation_plate_mk1",
    stats: {
      mass: 60, hp: 60,
      tensile: 100_000_000,
      hardness: 0.05,
      thermalConductivity: 0.0001,
      thermalEmissivity: 0.05,
    },
  }),
  defineModule({
    id: "hull_triangle_1x1",
    name: "Hull Triangle Mk.I",
    category: "structural",
    tier: 1,
    cells: { w: 1, h: 1 },
    sprite: "hull_triangle_1x1",
    stats: {
      mass: 60, hp: 40,
      tensile: 400_000_000,
      hardness: 0.3,
      thermalConductivity: 1.0,
      thermalEmissivity: 0.7,
    },
  }),
  defineModule({
    id: "hull_triangle_1x1_mirror",
    name: "Hull Triangle Mk.I (Mirror)",
    category: "structural",
    tier: 1,
    cells: { w: 1, h: 1 },
    sprite: "hull_triangle_1x1_mirror",
    stats: {
      mass: 60, hp: 40,
      tensile: 400_000_000,
      hardness: 0.3,
      thermalConductivity: 1.0,
      thermalEmissivity: 0.7,
    },
  }),
  defineModule({
    id: "hull_wedge_2x1",
    name: "Hull Wedge 2x1",
    category: "structural",
    tier: 1,
    cells: { w: 2, h: 1 },
    sprite: "hull_wedge_2x1",
    stats: {
      mass: 120, hp: 80,
      tensile: 400_000_000,
      hardness: 0.3,
      thermalConductivity: 1.0,
      thermalEmissivity: 0.7,
    },
  }),
  defineModule({
    id: "hull_wedge_2x1_mirror",
    name: "Hull Wedge 2x1 (Mirror)",
    category: "structural",
    tier: 1,
    cells: { w: 2, h: 1 },
    sprite: "hull_wedge_2x1_mirror",
    stats: {
      mass: 120, hp: 80,
      tensile: 400_000_000,
      hardness: 0.3,
      thermalConductivity: 1.0,
      thermalEmissivity: 0.7,
    },
  }),
  defineModule({
    id: "truss_square_1x1",
    name: "Truss Frame 1x1",
    category: "structural",
    tier: 1,
    cells: { w: 1, h: 1 },
    sprite: "truss_square_1x1",
    noCollision: true,
    stats: {
      mass: 40, hp: 50,
      tensile: 350_000_000,
      hardness: 0.2,
      thermalConductivity: 0.8,
      thermalEmissivity: 0.6,
    },
  }),
  defineModule({
    id: "truss_triangle_1x1",
    name: "Truss Triangle 1x1",
    category: "structural",
    tier: 1,
    cells: { w: 1, h: 1 },
    sprite: "truss_triangle_1x1",
    noCollision: true,
    stats: {
      mass: 30, hp: 40,
      tensile: 350_000_000,
      hardness: 0.2,
      thermalConductivity: 0.8,
      thermalEmissivity: 0.6,
    },
  }),
  defineModule({
    id: "truss_triangle_1x1_mirror",
    name: "Truss Triangle 1x1 (Mirror)",
    category: "structural",
    tier: 1,
    cells: { w: 1, h: 1 },
    sprite: "truss_triangle_1x1_mirror",
    noCollision: true,
    stats: {
      mass: 30, hp: 40,
      tensile: 350_000_000,
      hardness: 0.2,
      thermalConductivity: 0.8,
      thermalEmissivity: 0.6,
    },
  }),
  defineModule({
    id: "truss_beam_2x1",
    name: "Truss Beam",
    category: "structural",
    tier: 1,
    cells: { w: 2, h: 1 },
    sprite: "truss_beam_2x1",
    noCollision: true,
    stats: {
      mass: 70, hp: 90,
      tensile: 400_000_000,
      hardness: 0.2,
      thermalConductivity: 0.8,
      thermalEmissivity: 0.6,
    },
  }),
];
